import styled from 'styled-components';

export const FileUploaderLayout = styled.div`
    display: flex;
    flex-direction: column;

    .uploadInfo {
        display: flex;
        flex-direction: column;

        * {
            align-self: center;
        }

        owc-icon {
            padding-bottom: 16px;
            font-size: 5.5rem;
        }
    }

    .uploadAction {
        display: flex;
        justify-content: center;
        padding-top: 16px;
    }
`;

export const FileSection = styled.div`
    padding: 16px 0;
`;
